module.exports = __webpack_public_path__ + "img/horizontal-distribute.0c7a4831.svg";